<!--
 * @Author: pyx 3245266940@qq.com
 * @Date: 2023-04-18 14:33:15
 * @LastEditors: pyx 3245266940@qq.com
 * @LastEditTime: 2023-04-18 15:19:29
 * @FilePath: \org-wx-front\src\components\Mine\popup.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="popWrap rowJcAc">
        <div class="popContetBox">
            <div class="titleBox">{{title}}</div>
            <div class="tipsBox">{{tips}}</div>
            <div class="flexRow">
                <div class="btn cancel" @click="clickCancel">取消</div>
                <div class="btnLine"></div>
                <div class="btn ensure" @click="clickEnsure">确定</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['title','tips'],
    data() {
        return {

        }
    },
    methods: {
        clickCancel() {
            this.$emit('event',{type: 'cancel'})
        },
        clickEnsure() {
            this.$emit('event',{type: 'ensure'})
        }
    }
}
</script>
<style scoped>
.popWrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 100;
}
.popContetBox {
    width: 3.20rem;
    /* height: 1.8rem; */
    background-color: #ffffff;
    border-radius: .08rem;
    margin-top: -0.4rem;
    overflow: hidden;
}
.titleBox {
    text-align: center;
    font-weight: 600;
    font-size: .16rem;
    line-height: .22rem;
    padding-top: .32rem;
    color: #191C27;
}
.tipsBox {
    text-align: center;
    font-size: .16rem;
    line-height: .22rem;
    color: #9EA5BB;
    padding: .16rem .24rem .32rem;
    border-bottom: 1px solid #DCDEE0;
}
.btn {
    height: .56rem;
    flex: 1;
    text-align: center;
    line-height: .56rem;
    font-size: .16rem;
}
.cancel {
    color: #191C27;
}
.ensure {
    color: #6985FF;
}
.btnLine {
    width: 1px;
    height: .56rem;
    background-color: #DCDEE0;
}
</style>